import { useContext, useMemo } from 'react';

import { AuthContext } from '@/providers/auth/types';

export type UserInfo = {
  email: string | undefined;
  name: string | undefined;
  userId: string | undefined;
};

const atlasUserIdentifier = 'https://crossnokaye.com/atlasUserIdentifier';

export const useUser = (): UserInfo => {
  const ctx = useContext(AuthContext);
  const userInfo = useMemo(() => {
    const userInfo: UserInfo = {
      email: ctx?.user?.email || undefined,
      name: ctx?.user?.name || undefined,
      userId: ctx?.user?.[atlasUserIdentifier] || undefined,
    };

    return userInfo;
  }, [ctx?.user]);

  return userInfo;
};
